import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why" },
  { label: "Insights", href: "/blog" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-cream/80 border-b border-bordersoft"
          : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-2 group" data-testid="logo-link">
          <div className="w-9 h-9 bg-forest flex items-center justify-center">
            <span className="text-cream font-serif text-2xl leading-none">G</span>
          </div>
          <div className="leading-tight">
            <div className={`font-serif text-xl ${scrolled ? "text-forest" : "text-cream"}`}>
              Greenroute
            </div>
            <div className={`text-[10px] uppercase tracking-[0.25em] ${scrolled ? "text-sage" : "text-cream/70"}`}>
              Estate Management
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm tracking-wide link-underline ${
                scrolled ? "text-ink hover:text-forest" : "text-cream/90 hover:text-cream"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-quote"
            className={`px-5 py-2.5 text-sm tracking-wide transition-colors duration-300 ${
              scrolled
                ? "bg-forest text-cream hover:bg-forest/90"
                : "bg-cream text-forest hover:bg-cream/90"
            }`}
          >
            Request Quote
          </a>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className={`md:hidden ${scrolled ? "text-forest" : "text-cream"}`}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-cream border-t border-bordersoft" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-ink text-base"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="bg-forest text-cream px-5 py-3 text-sm tracking-wide text-center"
              data-testid="mobile-cta-quote"
            >
              Request Quote
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
};

export default Navbar;
